import { SignupChargeDetails } from "features/types";
import { useMemo } from "react";

function useSignupCharge(signupCharge?: SignupChargeDetails | null) {
  const totalCharge = useMemo(() => {
    if (!signupCharge) return 0;
    const { signupFees } = signupCharge;
    if (!signupFees) return signupCharge.signupCharge;

    const totalFees = signupFees.reduce(
      (acc, fee) => acc + Number(fee.feeAmount),
      0
    );
    return Number(signupCharge.signupCharge) + totalFees;
  }, [signupCharge]);

  const totalRecurringCharge = useMemo(() => {
    if (!signupCharge) return 0;
    const { recurringFees } = signupCharge;
    if (!recurringFees) return signupCharge.recurringCharge;

    const totalReucrringFees = recurringFees.reduce(
      (acc, fee) => acc + Number(fee.feeAmount),
      0
    );

    return Number(signupCharge.recurringCharge) + totalReucrringFees;
  }, [signupCharge]);

  return { totalCharge, totalRecurringCharge };
}

export default useSignupCharge;
